import template from './adpDefinitionList.html';
import controller from './adpDefinitionList.controller';
import './adpDefinitionList.less';

let adpDefinitionListComponent = {
  restrict: 'E',
  bindings: {},
  template,
  transclude: true,
  controller
};

export default adpDefinitionListComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpDefinitionList/adpDefinitionList.component.js